/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Paper,
  Button,
  Select,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import useStyles from './styles'; // Importa los estilos desde Styles.js
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import { clientAxios8080 } from '../../../../configs/axios';
import LoadingOverlay from "../../../loading-overlay";

// Componente principal
function SitiosDetalle() {
  // Aplica los estilos
  const classes = useStyles();

  // Estado para los datos de sitios y el modal
  const [loading, setLoading] = useState(true);
  const [sitios, setSitios] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inmuebles, setInmuebles] = useState([]);
  const [consumo, setConsumo] = useState([]);
  const [criticidad, setCriticidad] = useState([]);
  const [modalSitioId, setModalSitioId] = useState(null);
  const [modalNombre, setModalNombre] = useState('');
  const [modalDireccion, setModalDireccion] = useState('');
  const [modalInternet, setModalInternet] = useState('');
  const [modalIncrementalInternet, setModalIncrementalInternet] = useState(0);
  const [modalIncrementalMpls, setModalIncrementalMpls] = useState(0);
  const [modalAnchoBandaPiso, setModalAnchoBandaPiso] = useState(0);
  const [modalIncrementalAnchoBanda, setModalIncrementalAnchoBanda] = useState(0);
  const [modalTotalAnchoBandaInicial, setModalTotalAnchoBandaInicial] = useState(0);
  const [modalTipoMedioPrincipal, setModalTipoMedioPrincipal] = useState('');
  const [modalProveedorMedio, setModalProveedorMedio] = useState('');
  const [modalIdTerceros, setModalIdTerceros] = useState('');
  const [modalTipoMedioRedundante, setModalTipoMedioRedundante] = useState('');
  const [modalProveedorMedioRedundante, setModalProveedorMedioRedundante] = useState('');
  const [modalIdTercerosRespaldo, setModalIdTercerosRespaldo] = useState('');
  const [modalISE, setModalISE] = useState(0);
  const [modalRouter, setModalRouter] = useState(0);
  const [modalModelador, setModalModelador] = useState(0);
  const [modalWLC, setModalWLC] = useState(0);
  const [modalInfoblox,setModalInfoblox]= useState(0);
  const [modalWlanExteriores, setModalWlanExteriores] = useState(0);
  const [modalWlanInteriores, setModalWlanInteriores] = useState(0);
  const [modalLanAltaDensidad, setModalLanAltaDensidad] = useState(0);
  const [modalLanMediaDensidad, setModalLanMediaDensidad] = useState(0);
  const [modalLanBajaDensidad, setModalLanBajaDensidad] = useState(0);
  const [modalInmuebleIdSelect, setModalInmuebleIdSelect] = useState('');
  const [modalConsumoIdSelect, setModalConsumoIdSelect]= useState('');
  const [modalCriticidadIdSelect, setModalCriticidadIdSelect]= useState('');
  const [searchValue, setSearchValue] = useState('');
  const [proveedorMedioError, setProveedorMedioError] = useState('');
  const [internetError, setInternetError] = useState('');
  const [idTercerosError, setIdTercerosError] = useState('');
  const [tipoMedioRedundanteError, setTipoMedioRedundanteError] = useState('');
  const [proveedorMedioRedundanteError, setProveedorMedioRedundanteError] = useState('');
  const [idTercerosRespaldoError, setIdTercerosRespaldoError] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [direccionError, setDireccionError] = useState('');
  const [inmuebleIdError, setInmuebleIdError] = useState('');
  const [consumoIdError, setConsumoIdError] = useState('');
  const [criticidadError,setCriticidadError] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [orderBy, setOrderBy] = useState('nodeId'); // Inicialmente, ordena por ID ascendente
  const [orderDirection, setOrderDirection] = useState('asc'); // Inicialmente, en orden ascendente
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Esto define rowsPerPage y su función para cambiar el valor

  const modalStyle = {
    position: 'absolute',
    width: '50%',
    bgcolor: 'background.paper',
    p: 4,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto',
    maxHeight: '100vh',
  };

  async function getSitio() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/sitio');
      const responseData = response.data.data;
      // Ordena los datos por 'id' de forma predeterminada
      responseData.sort((a, b) => a.id - b.id);
      setSitios(responseData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  async function getInmueble() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/inmueble');
      const responseData = response.data?.data?.filter((inmueble) => inmueble.status === true);
      setInmuebles(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getTipoConsumo() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/consumo');
      const responseData = response.data?.data?.filter((cons) => cons.status === true);
      setConsumo(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getCriticidad() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/criticidad/sitio');
      const responseData = response.data.data.filter((crit) => crit.status === true);
      console.log('Response Criticidad:', responseData);
      setCriticidad(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  
  const postSitio = async () => {
    try {
      const newSitioData = {
        nombreSitio: modalNombre,
        direccionInmueble: modalDireccion,
        tipoInmuebleId: modalInmuebleIdSelect,
        tipoConsumoId: modalConsumoIdSelect,
        claveCriticidadSitio: modalCriticidadIdSelect,
        internet: modalInternet,
        incrementalInternet: modalIncrementalInternet,
        incrementalMpls: modalIncrementalMpls,
        anchoBandaPiso: modalAnchoBandaPiso,
        incrementalAnchoBanda: modalIncrementalAnchoBanda,
        totalAnchoBandaInicial: modalTotalAnchoBandaInicial,
        tipoMedioPrincipal: modalTipoMedioPrincipal,
        proveedorMedio: modalProveedorMedio,
        idTerceros: modalIdTerceros,
        tipoMedioRedundante: modalTipoMedioRedundante,
        proveedorMedioRedundante: modalProveedorMedioRedundante,
        idTercerosRespaldo: modalIdTercerosRespaldo,
        ise: modalISE,
        router: modalRouter,
        modelador: modalModelador,
        wlc: modalWLC,
        infoblox: modalInfoblox,
        servWlanExteriores: modalWlanExteriores,
        servWlanInteriores: modalWlanInteriores,
        servLanAltaDensidad: modalLanAltaDensidad,
        servLanMediaDensidad: modalLanMediaDensidad,
        servLanBajaDensidad: modalLanBajaDensidad
      };

      const response = await clientAxios8080.post('/ms-catalogos/filtros/sitio', newSitioData);
      console.log('Datos que se enviarán en la solicitud POST:', newSitioData);

      if (response.status === 200) {
        // Show success alert for new record
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro agregado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response?.data?.error || 'Hubo un error al procesar la solicitud.',
        });
       
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const putSitio = async () => {
    try {
      const updatedSitioData = {
        id: modalSitioId,
        nombreSitio: modalNombre,
        direccionInmueble: modalDireccion,
        tipoInmuebleId: modalInmuebleIdSelect,
        tipoConsumoId: modalConsumoIdSelect,
        claveCriticidadSitio: modalCriticidadIdSelect,
        internet: modalInternet,
        incrementalInternet: modalIncrementalInternet,
        incrementalMpls: modalIncrementalMpls,
        anchoBandaPiso: modalAnchoBandaPiso,
        incrementalAnchoBanda: modalIncrementalAnchoBanda,
        totalAnchoBandaInicial: modalTotalAnchoBandaInicial,
        tipoMedioPrincipal: modalTipoMedioPrincipal,
        proveedorMedio: modalProveedorMedio,
        idTerceros: modalIdTerceros,
        tipoMedioRedundante: modalTipoMedioRedundante,
        proveedorMedioRedundante: modalProveedorMedioRedundante,
        idTercerosRespaldo:modalIdTercerosRespaldo,
        ise: modalISE,
        router: modalRouter,
        modelador: modalModelador,
        wlc: modalWLC,
        infoblox: modalInfoblox,
        servWlanExteriores: modalWlanExteriores,
        servWlanInteriores: modalWlanInteriores,
        servLanAltaDensidad: modalLanAltaDensidad,
        servLanMediaDensidad: modalLanMediaDensidad,
        servLanBajaDensidad: modalLanBajaDensidad,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/sitio', updatedSitioData);
      console.log('Datos que se enviarán en la solicitud PUT:', updatedSitioData);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro actualizado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getSitio();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response?.data?.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const deleteSitio = async (id) => {
    try {
      const response = await clientAxios8080.delete(`/ms-catalogos/filtros/sitio?id=${id}`);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro eliminado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getSitio();
      } else {
        setLoading(false);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response?.data?.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      console.error('Error al enviar la solicitud DELETE:', error);
    }
  };

  useEffect(() => {
    getInmueble()
    getTipoConsumo()
    getCriticidad()
    getSitio()
  }, []);

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setLoading(true);
    setIsModalOpen(true);
    setModalSitioId(null);
    setModalNombre('');
    setNombreError('');
    setModalDireccion('');
    setModalInternet('')
    setModalIncrementalInternet(0)
    setModalIncrementalMpls(0)
    setModalAnchoBandaPiso(0)
    setModalIncrementalAnchoBanda(0)
    setModalTotalAnchoBandaInicial(0)
    setModalTipoMedioPrincipal('')
    setModalProveedorMedio('')
    setModalIdTerceros('')
    setModalTipoMedioRedundante('')
    setModalProveedorMedioRedundante('')
    setModalIdTercerosRespaldo('')
    setModalISE(0)
    setModalRouter(0)
    setModalModelador(0)
    setModalWLC(0)
    setModalInfoblox(0)
    setModalWlanExteriores(0)
    setModalWlanInteriores(0)
    setModalLanAltaDensidad(0)
    setModalLanMediaDensidad(0)
    setModalLanBajaDensidad(0)
    setDireccionError('');
    setProveedorMedioError('');
    setProveedorMedioRedundanteError('');
    setIdTercerosError('');
    setIdTercerosRespaldoError('')
    setTipoMedioRedundanteError('')
    setInmuebleIdError('');
    setConsumoIdError('')
    setModalStatus(true);
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = (
    id,
    nombreSitio,
    direccion,
    tipoInmuebleId,
    tipoConsumoId,
    claveCriticidadSitio,
    internet,
    incrementalInternet,
    incrementalMpls,
    anchoBandaPiso,
    incrementalAnchoBanda,
    totalAnchoBandaInicial,
    tipoMedioPrincipal,
    proveedorMedio,
    idTerceros,
    tipoMedioRedundante,
    proveedorMedioRedundante,
    idTercerosRespaldo,
    ise,
    router,
    modelador,
    wlc,
    infoblox,
    servWlanExteriores,
    servWlanInteriores,
    servLanAltaDensidad,
    servLanMediaDensidad,
    servLanBajaDensidad,
    status
  ) => {
    setModalSitioId(id);
    setModalNombre(nombreSitio);
    setModalDireccion(direccion);
    setModalInmuebleIdSelect(tipoInmuebleId)
    setModalConsumoIdSelect(tipoConsumoId)
    setModalCriticidadIdSelect(claveCriticidadSitio)
    setModalInternet(internet)
    setModalIncrementalInternet(incrementalInternet)
    setModalIncrementalMpls(incrementalMpls)
    setModalAnchoBandaPiso(anchoBandaPiso)
    setModalIncrementalAnchoBanda(incrementalAnchoBanda)
    setModalTotalAnchoBandaInicial(totalAnchoBandaInicial)
    setModalTipoMedioPrincipal(tipoMedioPrincipal)
    setModalProveedorMedio(proveedorMedio)
    setModalIdTerceros(idTerceros)
    setModalTipoMedioRedundante(tipoMedioRedundante)
    setModalProveedorMedioRedundante(proveedorMedioRedundante)
    setModalIdTercerosRespaldo(idTercerosRespaldo)
    setModalISE(ise)
    setModalRouter(router)
    setModalModelador(modelador)
    setModalWLC(wlc)
    setModalInfoblox(infoblox)
    setModalWlanExteriores(servWlanExteriores)
    setModalWlanInteriores(servWlanInteriores)
    setModalLanAltaDensidad(servLanAltaDensidad)
    setModalLanMediaDensidad(servLanMediaDensidad)
    setModalLanBajaDensidad(servLanBajaDensidad)
    setModalStatus(status);
    setNombreError('');
    setDireccionError('');
    setProveedorMedioError('');
    setProveedorMedioRedundanteError('');
    setIdTercerosError('');
    setIdTercerosRespaldoError('')
    setTipoMedioRedundanteError('')
    setInmuebleIdError('');
    setConsumoIdError('');
    setCriticidadError('');
    setIsModalOpen(true);
  };

  // Maneja el cambio en el campo "Nombre"
  const handleNombreChange = (e) => {
    const newName = e.target.value;
    setModalNombre(newName);

    if (newName.trim().length === 0) {
      setNombreError('El nombre no puede estar vacío.');
    } else if (newName.trim().length < 3) {
      setNombreError('El nombre debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newName)) {
        setNombreError('');
      } else {
        setNombreError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  const handleDireccionChange = (e) => {
    const newDireccion = e.target.value;
    setModalDireccion(newDireccion);

    if (newDireccion.trim().length === 0) {
      setDireccionError('La dirección no puede estar vacía.');
    } else if (newDireccion.trim().length < 3) {
      setDireccionError('La dirección debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newDireccion)) {
        setDireccionError('');
      } else {
        setDireccionError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  const handleInternetChange = (e) => {
    const newInternet = e.target.value;
    setModalInternet(newInternet);
    
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newInternet)) {
        setInternetError('');
      } else {
        setInternetError('El texto contiene caracteres no permitidos.')
      }
  };
  
  const handleProveedorMedioChange = (e) => {
    const newProv = e.target.value;
    setModalProveedorMedio(newProv);

    if (newProv.trim().length === 0) {
      setProveedorMedioError('Proveedor Medio no puede estar vacía.');
    } else if (newProv.trim().length < 3) {
      setProveedorMedioError('Proveedor Medio debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newProv)) {
        setProveedorMedioError('');
      } else {
        setProveedorMedioError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  const handleIDTChange = (e) => {
    const newId = e.target.value;
    setModalIdTerceros(newId);

      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newId)) {
        setIdTercerosError('');
      } else {
        setIdTercerosError('El texto contiene caracteres no permitidos.')
      }
  }
  
  const handleTipoMedioRedundanteChange = (e) => {
    const newtipo = e.target.value;
    setModalTipoMedioRedundante(newtipo);

    const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

    if (textRegex.test(newtipo)) {
      setTipoMedioRedundanteError('');
    } else {
      setTipoMedioRedundanteError('El texto contiene caracteres no permitidos.')
    }
  }
  
  const handleProveedorRedundanteChange = (e) => {
    const newProv = e.target.value;
    setModalProveedorMedioRedundante(newProv);

    const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

    if (textRegex.test(newProv)) {
      setProveedorMedioRedundanteError('');
    } else {
      setProveedorMedioRedundanteError('El texto contiene caracteres no permitidos.')
    }
  }
  
  const handleIDTRespaldoChange = (e) => {
    const newId = e.target.value;
    setModalIdTercerosRespaldo(newId);

    const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

    if (textRegex.test(newId)) {
      setIdTercerosRespaldoError('');
    } else {
      setIdTercerosRespaldoError('El texto contiene caracteres no permitidos.')
    }
  }
  
  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (id) => {
    try {
      // Busca el sitio en el estado actual
      const sitioToUpdate = sitios.find((sitio) => sitio.id === id);

      // Realiza el cambio localmente en el estado
      setSitios((prevSitios) =>
        prevSitios.map((sitio) => {
          if (sitio.id === id) {
            const updatedSitioData = { ...sitio, status: !sitio.status };
            console.log('Status cambiado:', updatedSitioData); // Mostrar el arreglo actualizado
            return updatedSitioData;
          }
          return sitio;
        })
      );
      // Aquí se debe acceder directamente a sitioToUpdate en lugar de intentar acceder a sitio fuera del bloque map
      const updatedSitioData = {
        id: sitioToUpdate.id,
        nombreSitio: sitioToUpdate.nombreSitio,
        direccionInmueble: sitioToUpdate.direccionInmueble,
        tipoInmuebleId: sitioToUpdate.tipoInmuebleId,
        tipoConsumoId: sitioToUpdate.tipoConsumoId,
        claveCriticidadSitio: sitioToUpdate.claveCriticidadSitio,
        internet: sitioToUpdate.internet,
        incrementalInternet: sitioToUpdate.incrementalInternet,
        incrementalMpls: sitioToUpdate.incrementalMpls,
        anchoBandaPiso: sitioToUpdate.anchoBandaPiso,
        incrementalAnchoBanda: sitioToUpdate.incrementalAnchoBanda,
        totalAnchoBandaInicial: sitioToUpdate.totalAnchoBandaInicial,
        tipoMedioPrincipal: sitioToUpdate.tipoMedioPrincipal,
        proveedorMedio: sitioToUpdate.proveedorMedio,
        idTerceros: sitioToUpdate.idTerceros,
        tipoMedioRedundante: sitioToUpdate.tipoMedioRedundante,
        proveedorMedioRedundante: sitioToUpdate.proveedorMedioRedundante,
        idTercerosRespaldo:sitioToUpdate.idTercerosRespaldo,
        ise: sitioToUpdate.ise,
        router: sitioToUpdate.router,
        modelador: sitioToUpdate.modelador,
        wlc: sitioToUpdate.wlc,
        infoblox: sitioToUpdate.infoblox,
        servWlanExteriores: sitioToUpdate.servWlanExteriores,
        servWlanInteriores: sitioToUpdate.servWlanInteriores,
        servLanAltaDensidad: sitioToUpdate.servLanAltaDensidad,
        servLanMediaDensidad: sitioToUpdate.servLanMediaDensidad,
        servLanBajaDensidad: sitioToUpdate.servLanBajaDensidad,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/sitio', updatedSitioData);
      console.log('Datos que se enviarán en la solicitud PUT:', updatedSitioData);

      if (response.status === 200) {
        console.log('Sitio actualizado exitosamente.');
        const title = updatedSitioData.status ? 'Sitio activado exitosamente.' : 'Sitio desactivado exitosamente.';
        Swal.fire({
          position: 'center',
          icon: 'success',
          title,
          showConfirmButton: false,
          timer: 1200,
        });
      } else {
        console.error('Error al actualizar el sitio:', response.data.error);
      }
    } catch (error) {
      console.error('Error al enviar la solicitud PUT:', error);
    }
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    
    let newNombreError = '';
    let newDireccionError = '';
    const inmuebleIdToSave = modalInmuebleIdSelect;
    const consumoIdToSave = modalConsumoIdSelect;
    const criticidadIdToSave = modalCriticidadIdSelect;
    
    let newInmuebleIdError = '';
    
    
    if (modalNombre.trim().length === 0) {
      newNombreError = 'El nombre no puede estar vacío.';
    } else if (modalNombre.trim().length < 3) {
      newNombreError = 'El nombre debe tener al menos 3 caracteres.';
    }
    if (modalDireccion.trim().length === 0) {
      newDireccionError = 'La dirección no puede estar vacía.';
    } else if (modalDireccion.trim().length < 3) {
      newDireccionError = 'La dirección debe tener al menos 3 caracteres.';
    }

    if (!inmuebleIdToSave) {
      newInmuebleIdError = 'Debe seleccionar un inmueble.';
    }
    
    setNombreError(newNombreError);
    setDireccionError(newDireccionError);
    setInmuebleIdError(newInmuebleIdError);

    if (
      !newNombreError &&
      !newDireccionError 
    ) {
      try {
        if (modalSitioId !== null) {
          // Update existing site
          await putSitio();

        } else {
          // Add new site
          await postSitio();

          // Show success alert for new record
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro agregado con éxito',
            showConfirmButton: false,
            timer: 4200,
          });
        }

        // Close the modal and reset the fields
        setIsModalOpen(false);
        setModalSitioId(null);
        setModalNombre('');
        setModalDireccion('');
        if (modalNombre.trim().length >= 3) {
          setNombreError('');
        }
        if (modalDireccion.trim().length >= 3) {
          setDireccionError('');
        }
        getSitio();
      } catch (error) {
        // Show error alert
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: error.message || 'Hubo un error al procesar la solicitud.',
        });
      }
    }
  };

  /// Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = (id) => {
    setLoading(true);
    const sitio = sitios.find((i) => i.id === id); // Encuentra el sitio por su ID
    
    Swal.fire({
      title: `Estás a punto de eliminar el sitio: "${sitio.nombreSitio}".`,
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteSitio(id);
          
        } catch (error) {
          setLoading(false);
          console.error('Error al eliminar el inmueble:', error);

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el registro.',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
    });
  };

  const handleOrderByChange = (newOrderBy) => {
    if (newOrderBy === orderBy) {
      // Si se hace clic en la misma columna, cambia la dirección del orden
      setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Si se hace clic en una nueva columna, establece la columna de orden y el orden ascendente
      setOrderBy(newOrderBy);
      setOrderDirection('asc'); // Siempre ordena por 'id' en orden ascendente cuando cambia la columna
    }
  };

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const handleIncrInternetChange = (e) => {
    setModalIncrementalInternet(e.target.value === '' ? '' : Number(e.target.value));
  }

  const handleIncrMPLSChange = (e) => {
    setModalIncrementalMpls(e.target.value === '' ? '' : Number(e.target.value))
  }

  const handlePisoABChange = (e) => {
    setModalAnchoBandaPiso(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleIncrABChange = (e) => {
    setModalIncrementalAnchoBanda(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleTotalABChange = (e) => {
    setModalTotalAnchoBandaInicial(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleISEChange = (e) => {
    setModalISE(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleRouterChange = (e) => {
    setModalRouter(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleModeladorChange = (e) => {
    setModalModelador(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleWLCChange = (e) => {
    setModalWLC(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleInfoblox = (e) => {
    setModalInfoblox(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleWlanExteriores = (e) => {
    setModalWlanExteriores(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleWlanInteriores = (e) => {
    setModalWlanInteriores(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleLanAltaDensidad = (e) => {
    setModalLanAltaDensidad(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleLanMediaDensidad = (e) => {
    setModalLanMediaDensidad(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const handleLanBajaDensidad = (e) => {
    setModalLanBajaDensidad(e.target.value === '' ? '' : Number(e.target.value))
  }
  
  const filteredSitios = sitios.filter((sitio) => {
    const searchValueWithoutAccents = removeAccents(searchValue.toLowerCase());

    return (
      sitio.id.toString().includes(searchValueWithoutAccents) ||
      removeAccents(sitio.nombreSitio.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.direccionInmueble.toLowerCase()).includes(searchValueWithoutAccents)
    );
  });
  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Detalle del Catálogo para Sitios</h1>
      <div className={classes.addButtonStyle}>
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <div className={classes.selectContainer}>
          <Select id="rows-per-page-select" value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
            <MenuItem value={10}>Mostrar 10 elementos</MenuItem>
            <MenuItem value={30}>Mostrar 30 elementos</MenuItem>
            <MenuItem value={sitios.length}>Todos los elementos</MenuItem>
          </Select>
        </div>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} style={{ tableLayout: 'auto' }}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center" onClick={() => handleOrderByChange('id')}>
                Id {orderBy === 'id' && <span>{orderDirection === 'asc' ? '▲' : '▼'}</span>}
              </TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Direccion</TableCell>
              <TableCell align="center">Tipo de Inmueble</TableCell>
              <TableCell align="center">Tipo de Consumo</TableCell>
              <TableCell align="center">Criticidad</TableCell>
              <TableCell align="center">Internet</TableCell>
              <TableCell align="center">Incremental Internet</TableCell>
              <TableCell align="center">Incremental Mpls</TableCell>
              <TableCell align="center">Piso Ancho de Banda</TableCell>
              <TableCell align="center">Incremental Ancho de Banda</TableCell>
              <TableCell align="center">Total Ancho de Banda Inicial</TableCell>
              <TableCell align="center">Tipo Medio Principal</TableCell>
              <TableCell align="center">Proveedor Medio</TableCell>
              <TableCell align="center">Id Terceros</TableCell>
              <TableCell align="center">Tipo de Medio Redundante</TableCell>
              <TableCell align="center">Proveedor de Medio Redundante</TableCell>
              <TableCell align="center">Id  de Terceros Respaldo</TableCell>
              <TableCell align="center">ISE</TableCell>
              <TableCell align="center">Router</TableCell>
              <TableCell align="center">Modelador</TableCell>
              <TableCell align="center">WLC</TableCell>
              <TableCell align="center">Infoblox</TableCell>
              <TableCell align="center">Servicios Wlan Exteriores</TableCell>
              <TableCell align="center">Servicios Wlan Interiores</TableCell>
              <TableCell align="center">Servicios Lan Alta Densidad</TableCell>
              <TableCell align="center">Servicios Lan Media Densidad</TableCell>
              <TableCell align="center">Servicios Lan Baja Densidad</TableCell>
              <TableCell align="center">Estatus</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSitios.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              filteredSitios
                .slice(page * rowsPerPage, (page + 1) * rowsPerPage) // Filtrar las filas según la página actual
                .sort((a, b) => {
                  // Ordenar según la columna seleccionada y la dirección del orden
                  if (orderBy === 'id') {
                    return orderDirection === 'asc' ? a.id - b.id : b.id - a.id;
                  }
                  return 0;
                })
                .map((sitio) => (
                  <TableRow key={sitio.id}>
                    <TableCell align="center">{sitio.id}</TableCell>
                    <TableCell align="center">{sitio.nombreSitio}</TableCell>
                    <TableCell align="center">{sitio.direccionInmueble}</TableCell>
                    <TableCell align="center">{sitio.dstipoInmueble}</TableCell>
                    <TableCell align="center">{sitio.descriptipoConsumo}</TableCell>
                    <TableCell align="center">{sitio.dsCriticidadSitio}</TableCell>
                    <TableCell align="center">{sitio.internet}</TableCell>
                    <TableCell align="center">{sitio.incrementalInternet}</TableCell>
                    <TableCell align="center">{sitio.incrementalMpls}</TableCell>
                    <TableCell align="center">{sitio.anchoBandaPiso}</TableCell>
                    <TableCell align="center">{sitio.incrementalAnchoBanda}</TableCell>
                    <TableCell align="center">{sitio.totalAnchoBandaInicial}</TableCell>
                    <TableCell align="center">{sitio.tipoMedioPrincipal}</TableCell>
                    <TableCell align="center">{sitio.proveedorMedio}</TableCell>
                    <TableCell align="center">{sitio.idTerceros}</TableCell>
                    <TableCell align="center">{sitio.tipoMedioRedundante}</TableCell>
                    <TableCell align="center">{sitio.proveedorMedioRedundante}</TableCell>
                    <TableCell align="center">{sitio.idTercerosRespaldo}</TableCell>
                    <TableCell align="center">{sitio.ise}</TableCell>
                    <TableCell align="center">{sitio.router}</TableCell>
                    <TableCell align="center">{sitio.modelador}</TableCell>
                    <TableCell align="center">{sitio.wlc}</TableCell>
                    <TableCell align="center">{sitio.infoblox}</TableCell>
                    <TableCell align="center">{sitio.servWlanExteriores}</TableCell>
                    <TableCell align="center">{sitio.servWlanInteriores}</TableCell>
                    <TableCell align="center">{sitio.servLanAltaDensidad}</TableCell>
                    <TableCell align="center">{sitio.servLanMediaDensidad}</TableCell>
                    <TableCell align="center">{sitio.servLanBajaDensidad}</TableCell>
                    <TableCell align="center">
                      <div className={classes.centeredSwitch}>
                        <Switch checked={sitio.status} onChange={() => handleStatusChange(sitio.id)} className={classes.customSwitch} />
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                        <img
                          src={editarImage}
                          alt="Editar"
                          className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                          onClick={() =>
                            handleEditarClick(
                              sitio.id,
                              sitio.nombreSitio,
                              sitio.direccionInmueble,
                              sitio.tipoInmuebleId,
                              sitio.tipoConsumoId,
                              sitio.claveCriticidadSitio,
                              sitio.internet,
                              sitio.incrementalInternet,
                              sitio.incrementalMpls,
                              sitio.anchoBandaPiso,
                              sitio.incrementalAnchoBanda,
                              sitio.totalAnchoBandaInicial,
                              sitio.tipoMedioPrincipal,
                              sitio.proveedorMedio,
                              sitio.idTerceros,
                              sitio.tipoMedioRedundante,
                              sitio.proveedorMedioRedundante,
                              sitio.idTercerosRespaldo,
                              sitio.ise,
                              sitio.router,
                              sitio.modelador,
                              sitio.wlc,
                              sitio.infoblox,
                              sitio.servWlanExteriores,
                              sitio.servWlanInteriores,
                              sitio.servLanAltaDensidad,
                              sitio.servLanMediaDensidad,
                              sitio.servLanBajaDensidad,
                              sitio.status
                            )
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                        <img
                          src={eliminarImage}
                          alt="Eliminar"
                          className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                          onClick={() => handleEliminarClick(sitio.id)}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className={classes.pagination}>
            <IconButton onClick={() => setPage(0)} disabled={page === 0} aria-label="Primera página">
              <FirstPageIcon />
            </IconButton>
            <IconButton onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0} aria-label="Página anterior">
              <NavigateBeforeIcon />
            </IconButton>
            <span>
              {page + 1} de {Math.ceil(sitios.length / rowsPerPage)}
            </span>
            <IconButton
              onClick={() => setPage(Math.min(page + 1, Math.floor(sitios.length / rowsPerPage)))}
              disabled={page >= Math.floor(sitios.length / rowsPerPage)}
              aria-label="Página siguiente"
            >
              <NavigateNextIcon />
            </IconButton>
            <IconButton
              onClick={() => setPage(Math.floor(sitios.length / rowsPerPage))}
              disabled={page >= Math.floor(sitios.length / rowsPerPage)}
              aria-label="Última página"
            >
              <LastPageIcon />
            </IconButton>
          </div>
        </div>
      </TableContainer>
      {loading && <LoadingOverlay />}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={modalStyle}>
          <h2>{modalSitioId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <TextField
            label="Nombre"
            variant="outlined"
            value={modalNombre}
            onChange={handleNombreChange}
            className={classes.modalTextField}
            error={nombreError !== ''}
            helperText={nombreError}
          />
          <TextField
            label="Direccion"
            variant="outlined"
            multiline
            rows={4}
            value={modalDireccion}
            onChange={handleDireccionChange}
            className={classes.modalTextField}
            error={direccionError !== ''}
            helperText={direccionError}
          />
          <FormControl className={classes.modalTextField} error={Boolean(inmuebleIdError)}>
            <InputLabel id="inmueble-select-label" htmlFor="inmueble-select" {...(inmuebleIdError ? { style: { color: 'red' } } : {})}>
              Tipo de Inmueble
            </InputLabel>
            <Select
              labelId="inmueble-select-label"
              id="inmueble-select"
              value={modalInmuebleIdSelect}
              onChange={(e) => setModalInmuebleIdSelect(e.target.value)}
            >
              {inmuebles.map((inmueble) => (
                <MenuItem key={inmueble.tipoInmuebleId} value={inmueble.tipoInmuebleId}>
                  {inmueble.dstipoInmueble}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{inmuebleIdError}</FormHelperText>
          </FormControl>
          <FormControl className={classes.modalTextField} error={Boolean(consumoIdError)}>
            <InputLabel id="consumo-select-label" htmlFor="consumo-select" {...(consumoIdError ? { style: { color: 'red' } } : {})}>
              Tipo de Consumo
            </InputLabel>
            <Select
              labelId="consumo-select-label"
              id="consumo-select"
              value={modalConsumoIdSelect}
              onChange={(e) => setModalConsumoIdSelect(e.target.value)}
            >
              {consumo.map((tconsumo) => (
                <MenuItem key={tconsumo.tipoConsumoId} value={tconsumo.tipoConsumoId}>
                  {tconsumo.tipoConsumo}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{criticidadError}</FormHelperText>
          </FormControl>
          <FormControl className={classes.modalTextField} error={Boolean(criticidadError)}>
            <InputLabel id="criticidad-select-label" htmlFor="criticidad-select" {...(criticidadError ? { style: { color: 'red' } } : {})}>
              Criticidad
            </InputLabel>
            <Select
              labelId="criticidad-select-label"
              id="criticidad-select"
              value={modalCriticidadIdSelect}
              onChange={(e) => setModalCriticidadIdSelect(e.target.value)}
            >
              {criticidad.map((criticidadT) => (
                <MenuItem key={criticidadT.claveCriticidadSitio} value={criticidadT.claveCriticidadSitio}>
                  {criticidadT.dsCriticidadSitio}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{criticidadError}</FormHelperText>
          </FormControl>
          <TextField
            label="Internet"
            variant="outlined"
            value={modalInternet}
            onChange={handleInternetChange}
            className={classes.modalTextField}
            error={internetError !== ''}
            helperText={internetError}
          />
          <TextField
            label="Incremental Internet"
            type="number"
            variant="outlined"
            onChange={handleIncrInternetChange}
            value={modalIncrementalInternet}
            className={classes.modalTextField}
          />
          <TextField
            label="Incremental MPLS"
            type="number"
            variant="outlined"
            onChange={handleIncrMPLSChange}
            value={modalIncrementalMpls}
            className={classes.modalTextField}
          />
          <TextField
            label="Piso Ancho de Banda"
            type="number"
            variant="outlined"
            onChange={handlePisoABChange}
            value={modalAnchoBandaPiso}
            className={classes.modalTextField}
          />
          <TextField
            label="Incremental Ancho de Banda"
            type="number"
            variant="outlined"
            onChange={handleIncrABChange}
            value={modalIncrementalAnchoBanda}
            className={classes.modalTextField}
          />
          <TextField
            label="Total Ancho de Banda Inicial"
            type="number"
            variant="outlined"
            onChange={handleTotalABChange}
            value={modalTotalAnchoBandaInicial}
            className={classes.modalTextField}
          />
          <TextField
            label="Proveedor Medio"
            variant="outlined"
            value={modalProveedorMedio}
            onChange={handleProveedorMedioChange}
            className={classes.modalTextField}
            error={proveedorMedioError !== ''}
            helperText={proveedorMedioError}
          />
          <TextField
            label="Id Terceros"
            variant="outlined"
            value={modalIdTerceros}
            onChange={handleIDTChange}
            className={classes.modalTextField}
            error={idTercerosError !== ''}
            helperText={idTercerosError}
          />
          <TextField
            label="Tipo de Medio Redundante"
            variant="outlined"
            value={modalTipoMedioRedundante}
            onChange={handleTipoMedioRedundanteChange}
            className={classes.modalTextField}
            error={tipoMedioRedundanteError !== ''}
            helperText={tipoMedioRedundanteError}
          />
          <TextField
            label="Proveedor de Medio Redundante"
            variant="outlined"
            value={modalProveedorMedioRedundante}
            onChange={handleProveedorRedundanteChange}
            className={classes.modalTextField}
            error={proveedorMedioRedundanteError !== ''}
            helperText={proveedorMedioRedundanteError}
          />
          <TextField
            label="Id de Terceros Respaldo"
            variant="outlined"
            value={modalIdTercerosRespaldo}
            onChange={handleIDTRespaldoChange}
            className={classes.modalTextField}
            error={idTercerosRespaldoError !== ''}
            helperText={idTercerosRespaldoError}
          />
          <TextField
            label="ISE"
            type="number"
            variant="outlined"
            value={modalISE}
            onChange={handleISEChange}
            className={classes.modalTextField}
          />
          <TextField
            label="Router"
            type="number"
            variant="outlined"
            value={modalRouter}
            onChange={handleRouterChange}
            className={classes.modalTextField}
          />
          <TextField
            label="Modelador"
            type="number"
            variant="outlined"
            value={modalModelador}
            onChange={handleModeladorChange}
            className={classes.modalTextField}
          />
          <TextField
            label="WLC"
            type="number"
            variant="outlined"
            value={modalWLC}
            onChange={handleWLCChange}
            className={classes.modalTextField}
          />
          <TextField
            label="Infoblox"
            type="number"
            variant="outlined"
            value={modalInfoblox}
            onChange={handleInfoblox}
            className={classes.modalTextField}
          />
          <TextField
            label="Servicio Wlan Exteriores"
            type="number"
            variant="outlined"
            value={modalWlanExteriores}
            onChange={handleWlanExteriores}
            className={classes.modalTextField}
          />
          <TextField
            label="Servicio Wlan Interiores"
            type="number"
            variant="outlined"
            value={modalWlanInteriores}
            onChange={handleWlanInteriores}
            className={classes.modalTextField}
          />
          <TextField
            label="Servicios Lan Alta Densidad"
            type="number"
            variant="outlined"
            value={modalLanAltaDensidad}
            onChange={handleLanAltaDensidad}
            className={classes.modalTextField}
          />
          <TextField
            label="Servicios Lan Media Densidad"
            type="number"
            variant="outlined"
            value={modalLanMediaDensidad}
            onChange={handleLanMediaDensidad}
            className={classes.modalTextField}
          />
          <TextField
            label="Servicios Lan Baja Densidad"
            type="number"
            variant="outlined"
            value={modalLanBajaDensidad}
            onChange={handleLanBajaDensidad}
            className={classes.modalTextField}
          />
          <div className={classes.modalButtons}>
            <Button variant="contained" color="primary" onClick={handleGuardarClick} className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default SitiosDetalle;
